import { render } from "./page-learn.vue?vue&type=template&id=87756a22&scoped=true"
import script from "./page-learn.vue?vue&type=script&lang=js"
export * from "./page-learn.vue?vue&type=script&lang=js"

import "./page-learn.vue?vue&type=style&index=0&id=87756a22&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-87756a22"

export default script